import React, {useCallback, useRef, useState} from 'react';
import {Form} from "semantic-ui-react";
import PointDropdown from "../../../components/PointDropdown.jsx";
import ButtonCargo from "./buttons/buttonCargo";
import ButtonDocs from "./buttons/buttonDocs";
import ButtonPallets from "./buttons/buttonPallets";

const Addresses = ({label, form, onChange, parcelTypes, isCalc, isCalcV2, errors, companyId, customBlock}) => {

    const [width, setWidth] = useState(0);

    const roW = useRef(new ResizeObserver(el => {
        setWidth(el[0].target.clientWidth);
    }));

    const resizeW = useCallback((container) => {
        if (container) roW.current.observe(container);
        else if (roW.current) {
            roW.current.disconnect();
            setWidth(0);
        }
    }, [roW.current]);

    const btns = (w) => {
      return (<span ref={w && resizeW} className='d-flex'>
          <ButtonCargo
              isSelected={form.parcelType === parcelTypes.parcelTypeCargo}
              onClick={() => {
                  if (isCalcV2) ym(49255948, 'reachGoal', 'click-parcel-type-cargo')
                  onChange('parcelType', parcelTypes.parcelTypeCargo)
              }}
          />
          <ButtonDocs
              isSelected={form.parcelType === parcelTypes.parcelTypeDoc}
              onClick={() => {
                  if (isCalcV2) ym(49255948, 'reachGoal', 'click-parcel-type-doc')
                  onChange('parcelType', parcelTypes.parcelTypeDoc)
              }}
          />
          {isCalcV2 && <ButtonPallets
              isSelected={form.parcelType === parcelTypes.parcelTypePallets}
              onClick={() => {
                  if (isCalcV2) ym(49255948, 'reachGoal', 'click-parcel-type-pallets')
                  onChange('parcelType', parcelTypes.parcelTypePallets)
              }}
          />}
      </span>)
    }

    return (
        <div className={`addresses-form ${label ? '' : 'addresses-form_no-label'}`}>
            {label && <div className='form__header'>Подбор лучшего тарифа для Вашего отправления</div>}
            <Form className='form__inputs'>
                {!customBlock && <Form.Group widths='equal'>
                    <PointDropdown
                        width={width}
                        error={!!errors['shipmentAddress']}
                        isCalc={isCalc}
                        label={'Откуда'}
                        name={'shipment'}
                        form={form}
                        onChange={(name, value, doNotChangeField) => {
                            onChange(name, value);
                            ((value || {}).fullName && !doNotChangeField) && setTimeout(() => document.getElementById('point-delivery').children[0].focus(), 100);
                        }}
                        companyId={companyId}
                    />
                    <PointDropdown
                        width={width}
                        error={!!errors['deliveryAddress']}
                        isCalc={isCalc}
                        label={'Куда'}
                        name={'delivery'}
                        form={form}
                        onChange={(name, value) => onChange(name, value)}
                        companyId={companyId}
                    />
                    {(!isCalcV2 || (isCalcV2 && !label)) && btns(true)}
                </Form.Group>}
                {(isCalcV2 && label) && <Form.Group className='addresses-form__calc-btns'>
                    {btns()}
                </Form.Group>}
                {customBlock && customBlock}
            </Form>
        </div>
    );
};

export default Addresses;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/addresses.jsx